import styled from "styled-components";
import {
  BORDER_COLORS,
  COLORS,
  LAYER_COLORS,
  PRIMARY_COLORS,
} from "../../../constants/design/colors";
import { SPACING } from "../../../constants/design/spacing";

export const NotificationWrapper = styled.div<{ isRead?: boolean }>`
  display: flex;
  padding: ${SPACING.three}px;
  background-color: ${({ isRead }) =>
    isRead ? "transparent" : LAYER_COLORS.two};
  transition: 0.1s ease-in-out;
  border-bottom: 1px solid ${BORDER_COLORS.two};

  &:hover {
    background-color: ${LAYER_COLORS.one};
  }
`;

export const IconWrapper = styled.div<{
  backgroundColor?: string;
  isRead?: boolean;
}>`
  width: fit-content;
  height: fit-content;
  background-color: ${({ backgroundColor }) =>
    backgroundColor ?? "transparent"};
  border-radius: 50%;
  margin-right: ${SPACING.two}px;
  justify-content: center;
  display: grid;
  align-items: center;
  margin-top: ${SPACING.one}px;
  position: relative;
`;

export const Icon = styled.img`
  width: 32px;
  height: 32px;
  padding: ${SPACING.two}px;
`;

export const LogoIcon = styled(Icon)`
  padding: 0 !important;
  background: black;
  border-radius: 50%;
`;

export const SvgIconWrapper = styled.div<{ $color: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: ${SPACING.two}px;

  svg {
    stroke: ${({ $color }) => $color};
  }
`;

// Small action indicator overlaid on the bottom-right of a token logo, so a
// balance notification shows BOTH the asset (logo) and the action (deposit /
// withdraw / receive) at a glance. Parent (IconWrapper) is position: relative.
export const ActionBadge = styled.div<{ backgroundColor?: string }>`
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${({ backgroundColor }) =>
    backgroundColor ?? COLORS.blue.one};
  border: 1.5px solid ${LAYER_COLORS.one};
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 9px;
    height: 9px;
    padding: 0;
  }
`;

export const ReadIndicator = styled.span<{ $color?: string }>`
  position: absolute;
  width: 6px;
  height: 6px;
  bottom: 2px;
  right: 2px;
  border-radius: 50%;
  background: ${({ $color }) => $color ?? COLORS.blue.one};
  transition: 0.2s all ease-in-out;
`;

export const TextWrapper = styled(IconWrapper)`
  background: ${PRIMARY_COLORS.one};
  color: ${PRIMARY_COLORS.on};
  min-width: 32px;
  min-height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
`;
